module.exports = __webpack_public_path__ + "089aab7a533a120abe270615dfb3e096.svg";